import { __awaiter } from "tslib";
import { PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS, } from '@as-react/common-types';
import { axiosClient } from '@as-react/common-utils';
import { stringify } from 'qs';
class SearchApi {
    constructor() {
        this.searchSuggestions = (servicesApi, defaultRequestParams, query) => __awaiter(this, void 0, void 0, function* () {
            if (!query) {
                return null;
            }
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/aem/search/suggestion`,
                params: {
                    query,
                    mainWebshop: defaultRequestParams.mainWebshop,
                    language: defaultRequestParams.language,
                },
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.searchContentSuggestion = (servicesApi, elasticsearchIndex, q) => __awaiter(this, void 0, void 0, function* () {
            if (q) {
                try {
                    const axiosConfig = {
                        method: 'GET',
                        url: `${servicesApi}api/aem/search/suggestion/content`,
                        params: {
                            index: elasticsearchIndex,
                            q,
                        },
                        withCredentials: true,
                    };
                    const result = yield axiosClient.request(axiosConfig);
                    return result.data;
                }
                catch (_a) {
                    return null;
                }
            }
            return null;
        });
    }
    getProductCountPerStore(servicesEndpoint, authenticationConfig, fredhopperSegment, urlState, isShoplanding, filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesEndpoint}api/search/${authenticationConfig.market}/search/productcountperstore`,
                params: {
                    anaLang: authenticationConfig.anaLang,
                    fictiveWebShop: authenticationConfig.fictiveWebShop,
                    locale: authenticationConfig.locale,
                    market: authenticationConfig.market,
                    mainWebShop: authenticationConfig.mainWebshop,
                    segment: fredhopperSegment,
                    query: urlState.q,
                    page: urlState.page,
                    platform: isShoplanding
                        ? PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.shoplanding
                        : PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.public_site,
                    filter,
                },
                paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
            };
            try {
                const request = yield axiosClient.request(axiosConfig);
                return request.data;
            }
            catch (_a) {
                return [];
            }
        });
    }
    searchFredhopperProducts(servicesEndpoint, defaultRequestParams, productId, productColourId) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesEndpoint}api/aem/search/campaign`,
                params: {
                    mainWebShop: defaultRequestParams.mainWebshop,
                    locale: defaultRequestParams.language,
                    anaLang: defaultRequestParams.anaLang,
                    shopId: defaultRequestParams.shopId,
                    productId,
                    productColourId,
                },
            };
            const request = yield axiosClient.request(axiosConfig);
            return request.data;
        });
    }
}
export default new SearchApi();
